<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar :logo=logoPath v-if="!this.$store.getters.isBlocked">
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: 'Logout',
            icon: 'ni ni-user-run text-primary',
            path: '/logout'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Switch',
            icon: 'ni ni-compass-04 text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Go to Instagram', path: '/mysynchronicity-instagram' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Go to Facebook', path: '/mysynchronicity-facebook' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-chart-pie-35 text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Overview', path: '/mysynchronicity-linkedin' }"></sidebar-item>
        </sidebar-item>
        <!--PROFILE-->
        <sidebar-item
          :link="{
            name: 'Profile',
            icon: 'ni ni-circle-08 text-primary',
            path: '/linkedin/profile'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Linkedin',
            icon: 'ni ni-planet text-primary',
            path: '/linkedin'
          }"
        >
          <sidebar-item
            :link="{ name: 'Set new configuration', path: '/linkedin/set-user-configuration' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Existing Configuration', path: '/linkedin/get-user-configuration' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Report per day', path: '/linkedin/get-user-report' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Organic growth', path: '/linkedin/organic-growth' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Sales navigator',
            icon: 'ni ni-money-coins text-primary',
            path: '/linkedin/sales'
          }"
        >
          <sidebar-item
            :link="{ name: 'Set new configuration', path: '/linkedin/sales/set-user-configuration' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Existing Configuration', path: '/linkedin/sales/get-user-configuration' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Report per day', path: '/linkedin/sales/get-user-report' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="roleAdmin"
                      :link="{ name: 'Admin Panel', path: '/linkedin/admin-panel' }"></sidebar-item>
<!--        <sidebar-item v-if="$store.getters.getReferrer==='YSY'"-->
<!--                      :link="{ name: 'Upgrade plan', path: '/linkedin/upgradeplan' }"></sidebar-item>-->
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './SampleNavbar.vue';
import ContentFooter from './SampleFooter.vue';
import DashboardContent from '../Argon/Layout/Content.vue';
import {FadeTransition} from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  data() {
    return {
      roleAdmin: false,
      logoPath: "https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/partners/".concat(this.$store.getters.getReferrer.toUpperCase(), ".png"),
    }
  },
  created() {

    if (this.$store.getters.getUserRole === 'admin') {
      this.roleAdmin = true
    }
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  }
};
</script>
